// src/pages/MemberRights.js - RULING 306 (Bob 2026-10-12, "all"): "Your rights as a union member (LMRDA)".
// Opened from the quiet link at the foot of every screen (item 1), the member's welcome card (item 2) and the Agreements page
// (item 3). Officers also see their own duties (item 4). Sourced and plain, no commentary (item 5). The text is
// src\data\lmrdaRights.js - this file only draws it.
import React from 'react';
import { INTRO, SECTION_105, MEMBER_RIGHTS, OFFICER_DUTIES, SOURCES, isOfficerView } from '../data/lmrdaRights';
import { activate } from '../data/a11yActivate';   // pass 2: role, tabIndex and Enter/Space from one tested helper

const C = { text: '#F4F6F8', dim: '#8AA4BF', line: '#2E4A6B', bg: '#0A1628', accent: '#E8A020' };

function Item({ x }) {
  return (
    <div style={{ padding: '10px 0', borderTop: '1px solid ' + C.line }}>
      <div style={{ fontSize: 14, fontWeight: 700, color: C.text }}>{x.title} <span style={{ fontSize: 11, fontWeight: 400, color: C.dim }}>(Section {x.sec})</span></div>
      <div style={{ fontSize: 13, color: C.text, lineHeight: 1.55, marginTop: 4 }}>{x.text}</div>
    </div>
  );
}

export default function MemberRights({ user, onNavigate }) {
  const officer = isOfficerView(user);
  return (
    <div>
      <div className="topbar"><h1 className="topbar-title">Your rights as a union member</h1></div>
      <div className="page-content" style={{ maxWidth: 820 }}>
        <div className="card" style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 13, color: C.text, lineHeight: 1.6 }}>{INTRO}</div>
          <div style={{ fontSize: 12, color: C.dim, marginTop: 8, fontStyle: 'italic' }}>"{SECTION_105}" (LMRDA Section 105)</div>
        </div>
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-header"><div className="card-title">Your rights as a member</div></div>
          {MEMBER_RIGHTS.map(x => (
            <div key={x.sec + x.title}>
              <Item x={x} />
              {x.where === 'agreements' && onNavigate ? (
                <div style={{ fontSize: 12, marginBottom: 6 }}>
                  <span style={{ color: C.accent, cursor: 'pointer' }} {...activate(() => onNavigate('agreements'))}>Your agreements are on the Agreements page.</span>
                </div>
              ) : null}
            </div>
          ))}
        </div>
        {officer ? (
          <div className="card" style={{ marginBottom: 16 }}>
            <div className="card-header"><div className="card-title">Your duties as an officer</div></div>
            <div style={{ fontSize: 12, color: C.dim, marginBottom: 4 }}>Shown to officers. Your handbook carries the same list.</div>
            {OFFICER_DUTIES.map(x => <Item key={x.sec + x.title} x={x} />)}
          </div>
        ) : null}
        <div className="card">
          <div className="card-header"><div className="card-title">The full text</div></div>
          <div style={{ fontSize: 13, color: C.text, lineHeight: 1.8 }}>
            {SOURCES.map(s => (<div key={s.url}><a href={s.url} target="_blank" rel="noopener noreferrer" style={{ color: C.accent }}>{s.label}</a></div>))}
          </div>
          <div style={{ fontSize: 11, color: C.dim, marginTop: 8 }}>This page is a summary. Where it and the Act differ, the Act governs.</div>
        </div>
      </div>
    </div>
  );
}
